<form [formGroup]="addDevForm" (ngSubmit)="addDevice()">

  <div class="form-group pb-3">
    <label>
      <strong>
        {{'SERIAL_NUMBER' | translate}}
        <span matTooltip="{{ 'TOOLTIP_SERIAL_NUMBER' | translate}}" class="fa fa-fw fa-circle-info"></span>
      </strong>
    </label>

    <div class="d-flex">
      <input
        class="form-control"
        type="text"
        placeholder="{{'SERIAL_NUMBER' | translate }}"
        formControlName="id"
        name="devAddId"
        >

        @if (!devValidated) {
          <div
            class="input-group-append"
            matTooltip="{{ 'ID_VALIDATION_INFO' | translate }}"
            [hidden]="addDevForm.controls['id'].valid || addDevForm.controls['id'].pristine"
            >
            <div class="input-group-text alert-danger">
              <span class="fa-light fa-fw fa-info"></span>
            </div>
          </div>
        }
      </div>
    </div>

    @if (!devValidated) {
      <div class="form-group">
        <button type="submit" class="btn btn-outline-primary gray-bg mr-1" [disabled]="!addDevForm.valid">
          <span class="fa-light fa-check"></span> {{ 'VERIFY' | translate }}
        </button>
      </div>
    }

    @if (devValidated) {
      <div>
        @if (!newDevice) {
          <div class="form-group" style="margin-top: -20px; padding-bottom: 28px;">
            <strong>{{'DEVICE_TYPE' | translate}}:</strong> {{ getDevType() }}
          </div>
        }
        @if (newDevice) {
          <div class="form-group">
            <div class="from-group"><label><strong>{{'DEVICE_TYPE' | translate}}</strong></label></div>
            <mat-form-field appearance="outline">
              <mat-select formControlName="devType">
                <mat-option value="" disabled>{{'DEVICE_TYPE' | translate}}</mat-option>
                @for (devType of deviceTypeList; track devType) {
                  <mat-option [value]="devType.value">
                    {{devType.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        <div class="form-group" style="margin-top: -28px;">
          <div class="from-group"><label><strong>{{'LOCATION' | translate}}</strong></label></div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="locationId">
              <mat-option value="" disabled>{{'LOCATION' | translate}}</mat-option>
              @for (loc of locations; track loc) {
                <mat-option [value]="loc.id">
                  {{loc.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group" style="margin-top: -15px;">
          <label><strong>{{'NAME' |translate}}</strong></label>
          <input
            type="text"
            class="form-control"
            placeholder="{{'NAME' |translate}}"
            formControlName="name"
            name="name"
            >
          </div>
          @if (responseDev.gsmNumber) {
            <div class="form-group">
              <strong>{{ 'PHONE_NUMBER' |translate }}:</strong> {{responseDev.gsmNumber}}
            </div>
          }
          <div class="form-group pt-3">
            <button
              class="btn btn-primary mr-1"
              [disabled]="(addDevForm.invalid || addDevForm.pristine || deviceIsBeingAdded)"
              #formSubmitButton type="submit"
              >
              <div class="d-flex align-items-center">
                @if (deviceIsBeingAdded) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
                @if (!deviceIsBeingAdded) {
                  <span class="fa-light fa-floppy-disk"></span>
                }
                <span class="ml-2">{{'SAVE' |translate}}</span>
              </div>
            </button>
            <button type="reset" class="btn btn-outline-danger ml-3" (click)="resetAddForm()">
              <span class="fa-light fa-xmark"></span>
              {{'CANCEL' |translate}}
            </button>
          </div>
        </div>
      }
    </form>
